export default "__VITE_ASSET__73c46f79__"